"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarqueeAttributedImage;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _marqueeAttributionBlock = _interopRequireDefault(require("./marquee-attribution-block.js"));
var _image = require("@site/pattern-library-core/image");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const ImageWrapper = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "ImageWrapper",
  class: "pl-i12yyqjq",
  vars: {
    "i12yyqjq-2": [({
      attributionPosition
    }) => attributionPosition === 'bottom-left' || attributionPosition === 'bottom-right' ? 'flex-end' : 'flex-start']
  }
});
const StyledImage = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "StyledImage",
  class: "pl-s19v198g"
});

/**
 * TODO: refactor to normalize with feature blade version.
 *
 * Render image with attribution.
 *
 * @param {Object} props React props
 * @param {string} props.attribution attribution text
 * @param {string} props.imageUrl image url
 * @param {string} props.imageAlt image alt text
 * @param {string} props.attributionPosition attribution text position
 * @param {string} props.tabletAttributionPosition tablet attribution text position
 * @returns {React.ReactElement} Attributed Image component
 * @public
 */
function MarqueeAttributedImage({
  attribution,
  browserImage = {},
  attributionPosition = 'bottom-right',
  tabletAttributionPosition = 'bottom-left'
}) {
  const {
    url,
    altText,
    width = 1,
    height = 1
  } = browserImage;
  return /*#__PURE__*/_react.default.createElement(ImageWrapper, {
    "data-cy": "attributed-image",
    attributionPosition: attributionPosition
  }, /*#__PURE__*/_react.default.createElement(_marqueeAttributionBlock.default, {
    attribution: attribution,
    attributionPosition: attributionPosition,
    tabletAttributionPosition: tabletAttributionPosition
  }), url && /*#__PURE__*/_react.default.createElement(StyledImage, {
    url: url,
    altText: altText,
    width: width,
    height: height
  }));
}
MarqueeAttributedImage.propTypes = {
  attribution: _propTypes.default.string,
  browserImage: _propTypes.default.shape(_image.imgPropShape),
  attributionPosition: _propTypes.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
  tabletAttributionPosition: _propTypes.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right'])
};